<div class="microsoft-callback-page">
  <div class="microsoft-callback-loader" *ngIf="processing"></div>

  <div class="microsoft-callback-error" *ngIf="!processing && errorMessage">
    <p class="microsoft-callback-error-message">{{ errorMessage }}</p>
    <div class="microsoft-callback-actions">
      <button type="button" class="submit-btn btn btn-primary" (click)="retryMicrosoftLogin()">
        Try Microsoft sign-in again
      </button>
      <button type="button" class="submit-btn btn btn-outline-secondary" (click)="goToManualLogin()">
        Go to login
      </button>
    </div>
  </div>
</div>
